import React from "react";
import { Link } from "react-scroll";

export default function NavBar() {
  return (
    <nav className="sticky top-0 flex flex-wrap items-center justify-center w-full py-4 md:py-0 px-4 text-lg text-gray-700 bg-slate-700">
      <div className="hidden w-full md:flex md:items-center md:w-auto">
        <ul
          className="
              pt-4
              text-base text-white
              md:flex
              md:justify-between 
              md:pt-0"
        >
          <li>
            <Link
              className="md:p-4 py-2 block hover:text-purple-400 cursor-pointer"
              activeClass="active"
              to="home"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              className="md:p-4 py-2 block hover:text-purple-400 cursor-pointer"
              activeClass="active"
              to="about"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              className="md:p-4 py-2 block hover:text-purple-400 cursor-pointer"
              activeClass="active"
              to="works"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              Works
            </Link>
          </li>
          <li>
            <Link
              className="md:p-4 py-2 block hover:text-purple-400 cursor-pointer"
              activeClass="active"
              to="skills"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              Skills
            </Link>
          </li>
          <li>
            <Link
              className="md:p-4 py-2 block hover:text-purple-400 cursor-pointer"
              activeClass="active"
              to="contact"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
